var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#CCCCCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4358 32.682C15.1237 31.0223 17.4129 30.0898 19.7998 30.0898H34.1998C36.5868 30.0898 38.8759 31.0223 40.5638 32.682C42.2516 34.3416 43.1998 36.5927 43.1998 38.9398V42.4799C43.1998 43.4574 42.3939 44.2499 41.3998 44.2499C40.4057 44.2499 39.5998 43.4574 39.5998 42.4799V38.9398C39.5998 37.5315 39.0309 36.1809 38.0182 35.1851C37.0055 34.1893 35.632 33.6298 34.1998 33.6298H19.7998C18.3676 33.6298 16.9941 34.1893 15.9814 35.1851C14.9687 36.1809 14.3998 37.5315 14.3998 38.9398V42.4799C14.3998 43.4574 13.5939 44.2499 12.5998 44.2499C11.6057 44.2499 10.7998 43.4574 10.7998 42.4799V38.9398C10.7998 36.5927 11.748 34.3416 13.4358 32.682Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 12.3896C24.0177 12.3896 21.6 14.767 21.6 17.6996C21.6 20.6322 24.0177 23.0096 27 23.0096C29.9823 23.0096 32.4 20.6322 32.4 17.6996C32.4 14.767 29.9823 12.3896 27 12.3896ZM18 17.6996C18 12.8119 22.0294 8.84961 27 8.84961C31.9706 8.84961 36 12.8119 36 17.6996C36 22.5873 31.9706 26.5496 27 26.5496C22.0294 26.5496 18 22.5873 18 17.6996Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUser);
export default __webpack_public_path__ + "static/media/defaultUser.a8fea40c.svg";
export { ForwardRef as ReactComponent };